import SettingsAPIModel from './api/SettingsAPIModel';

export default class SettingsModel {
  countryCode?: string;

  constructor(settingsAPI: SettingsAPIModel) {
    this.countryCode = settingsAPI.country_code;
  }
}
